<div class="row" *ngIf='readOnly'>
  <div class="col-md-12 col-sm-12 table-responsive no-border">
    <form [formGroup]="deviceForm" novalidate>
      <table class="table table-condensed">
        <tbody>
          <tr>
            <td class="col-sm-12 no-left-padding no-right-padding">
              <table class="table table-inner table-condensed">
                <tbody>
                  <tr>
                    <th class="col-sm-3">Single Use Device?</th>
                    <th class="col-sm-3">Have a limited number of reuses?</th>
                    <th class="col-sm-3">Maximum Number of Reuses</th>
                    <th class="col-sm-3">Reprocessed Single Use Device?</th>
                  </tr>
                  <tr>
                    <td [ngClass]="isDefault('Single Use Device?')">
                      <label controlName="singleUseDevice"> </label> </td>
                    <td [ngClass]="isDefault('Have a limited number of reuses?')">
                      <label controlName="haveLimitedNoReuses"> </label> </td>
                    <td [ngClass]="isDefault('Maximum Number of Reuse')">
                      <label controlName="maxNumberOfReuse"> </label>
                    </td>
                    <td [ngClass]="isDefault('Reprocessed Single Use Device?')">
                      <label controlName="reprocessedSingleUseDevice"></label></td>
                  </tr>
                </tbody>
              </table>
            </td>
          </tr>
        </tbody>
      </table>
      <table class="table table-condensed">
        <tbody>
          <tr>
            <td class="col-sm-12 no-left-padding no-right-padding">
              <table class="table table-inner table-condensed">
                <tbody>
                  <tr>
                    <th class="col-sm-4">Human Cell, Tissue or Cellular or Tissue-Based Product (HCT/P)?</th>
                    <th class="col-sm-2">Combination Product?</th>
                    <th class="col-sm-1">Kit?</th>
                    <th class="col-sm-2">Device or IVD Reagents?</th>
                    <th class="col-sm-3">Consumables or Equipment?</th>
                  </tr>
                  <tr>
                    <td [ngClass]="isDefault('Human Cell, Tissue or Cellular or Tissue-Based Product')">
                      <label controlName="humanCellTissueProduct"></label></td>
                    <td [ngClass]="isDefault('Combination Product?')">
                      <label controlName="combinationProduct"> </label> </td>
                    <td [ngClass]="isDefault('Kit?')">
                      <label controlName="kit"> </label>
                    </td>
                    <td [ngClass]="isDefault('Device or IVD Reagents?')">
                      <label controlName="deviceOrIvdReagents"></label>
                    </td>
                    <td [ngClass]="isDefault('Consumables or Equipment?')">
                      <label controlName="consumablesOrEquipment"></label>
                    </td>
                  </tr>
                </tbody>
              </table>
            </td>
          </tr>
        </tbody>
      </table>
      <table class="table table-condensed">
        <tbody>
          <tr>
            <td class="col-sm-6 no-left-padding no-right-padding">
              <table class="table table-inner table-condensed">
                <tbody>
                  <tr>
                    <th class="col-sm-6">Packaged or Labeled as Sterile?</th>
                    <th class="col-sm-6">Need Sterilization Before Use?</th>
                  </tr>
                  <tr>
                    <td [ngClass]="isDefault('Packaged or Labeled as Sterile?')">
                      <label controlName="packagedOrLabeledAsSterile"></label> </td>
                    <td [ngClass]="isDefault('Need Sterilization Before Use?')">
                      <label controlName="needSterilizationBeforeUse"></label></td>
                  </tr>
                </tbody>
              </table>
            </td>
            <td class="col-sm-3 no-left-padding no-right-padding">
              <table class="table table-inner table-condensed" formArrayName="sterilizationMethodsForm">
                <tbody>
                  <tr>
                    <th class="col-sm-6">Sterilization Method(s)</th>
                  </tr>
                  <ng-container *ngIf="sterilizationMethodsForm.controls.length; else emptyTemplate1field">
                  <tr formGroupName="{{i}}" *ngFor="let value of sterilizationMethodsForm.controls; let i = index">
                    <td [ngClass]="isDefault('Sterilization Method(s)')">
                      <label controlName="value"></label> </td>
                  </tr>
                  </ng-container>
                </tbody>
              </table>
            </td>
            <td class="col-sm-3 no-left-padding no-right-padding">
              <table class="table table-inner table-condensed">
                <tbody>
                  <tr>
                    <th class="col-sm-6">Sterilization Method Description</th>
                  </tr>
                  <tr>
                    <td [ngClass]="isDefault('Sterilization Method Description')">
                      <label controlName="sterilizationMethodDescription"></label> </td>
                  </tr>
                </tbody>
              </table>
            </td>
          </tr>
        </tbody>
      </table>


      <table class="table table-condensed">
        <tbody>
          <tr>
            <td class="col-sm-6 no-left-padding no-right-padding">
              <table class="table table-inner table-condensed">
                <tbody>
                  <tr>
                    <th class="col-sm-5">Is the medical device software or does it incorporate software?</th>
                    <th class="col-sm-5">User Sterilization Required for Orthopedic Products?</th>
                    <th class="col-sm-2">Loaner Set/Orthopedic Set?</th>
                  </tr>
                  <tr>
                    <td [ngClass]="isDefault('Is the medical device software or does it incorporate software?')">
                      <label controlName="deviceSoftwareClassification"> </label>
                    </td>
                    <td [ngClass]="isDefault('User Sterilization Required for Orthopedic Products?')">
                      <label controlName="userSterilizationRequiredOrthopedicProducts"></label> </td>
                    <td [ngClass]="isDefault('Loaner Set/Orthopedic Set?')">
                      <label controlName="loanerOrthopedicSet"></label></td>
                  </tr>
                </tbody>
              </table>
            </td>
          </tr>
        </tbody>
      </table>



      <table class="table table-condensed">
        <tbody>
          <tr>
            <td class="col-sm-12 no-left-padding no-right-padding">
              <table formArrayName="clinicalSizeTypeForm" class="table table-inner table-condensed">
                <tbody>
                  <tr>
                     <!-- Custom grid layout, overriding the Bootsrap grid. The total of 16 columns equals to 100% (6.25% per column vs 12 columns at 8.3333% of the Bootsrap grid)-->
                     <th class="condensed-col-2">Clinical Size Type(s)</th>
                     <th class="condensed-col-2">Size Type Descriptions</th>
                     <th class="condensed-col-1">Language</th>
                     <th class="condensed-col-1">Size Value</th>
                     <th class="condensed-col-1">Range - Min Value</th>
                     <th class="condensed-col-1">Range - Max Value</th>
                     <th class="condensed-col-1">Size Unit</th>
                     <th class="condensed-col-2">Size Unit Descriptions</th>
                     <th class="condensed-col-1">Language</th>
                     <th class="condensed-col-4">Clinical Size Text</th>
                  </tr>
                  <ng-container *ngIf="clinicalSizeTypeForm.controls.length; else emptyTemplate10fields">
                  <tr formGroupName="{{i}}" *ngFor="let sizeGroup of clinicalSizeTypeForm.controls; let i = index">
                    <td [ngClass]="isDefault('Clinical Size Type(s)')">
                      <label controlName="sizeType"></label>
                    </td>
                    <td [ngClass]="isDefault('Clinical Size Type(s)')">
                      <table formArrayName="sizeTypeDescs" class="table table-inner table-condensed">
                        <tr formGroupName="{{t}}"
                          *ngFor="let type of sizeGroup.get('sizeTypeDescs').controls; let t = index">
                          <td class="no-top-padding-inner-table"
                            [ngClass]="isDefault('Clinical Size Type(s)')">
                            <label controlName="value"></label>
                          </td>
                        </tr>
                      </table>
                    </td>
                    <td [ngClass]="isDefault('Clinical Size Type(s)')">
                      <table formArrayName="sizeTypeDescs" class="table table-inner table-condensed">
                        <tr formGroupName="{{t}}"
                          *ngFor="let type of sizeGroup.get('sizeTypeDescs').controls; let t = index">
                          <td class="no-top-padding-inner-table"
                            [ngClass]="isDefault('Clinical Size Type(s)')">
                            <label controlName="language"></label>
                          </td>
                        </tr>
                      </table>
                    </td>

                    <td [ngClass]="isDefault('Clinical Size Type(s)')">
                      <label controlName="sizeValue"></label>
                    </td>
                    <td [ngClass]="isDefault('Clinical Size Type(s)')">
                      <label controlName="sizeMinValue"></label>
                    </td>
                    <td [ngClass]="isDefault('Clinical Size Type(s)')">
                      <label controlName="sizeMaxValue"></label>
                    </td>
                    <td [ngClass]="isDefault('Clinical Size Type(s)')">
                      <label controlName="sizeUnit"></label>
                    </td>
                    <td [ngClass]="isDefault('Clinical Size Type(s)')">
                      <table formArrayName="sizeUnitDescs" class="table table-inner table-condensed">
                        <tr formGroupName="{{t}}"
                          *ngFor="let unit of sizeGroup.get('sizeUnitDescs').controls; let t = index">
                          <td class="no-top-padding-inner-table"
                            [ngClass]="isDefault('Clinical Size Type(s)')">
                            <label controlName="value"></label>
                          </td>
                        </tr>
                      </table>
                    </td>
                    <td [ngClass]="isDefault('Clinical Size Type(s)')">
                      <table formArrayName="sizeUnitDescs" class="table table-inner table-condensed">
                        <tr formGroupName="{{t}}"
                          *ngFor="let type of sizeGroup.get('sizeUnitDescs').controls; let t = index">
                          <td class="no-top-padding-inner-table"
                            [ngClass]="isDefault('Clinical Size Type(s)')">
                            <label controlName="language"></label>
                          </td>
                        </tr>
                      </table>
                    </td>
                    <td [ngClass]="isDefault('Clinical Size Type(s)')">
                      <label controlName="clinicalSizeText"></label>
                    </td>
                  </tr>
                </ng-container>
                </tbody>
              </table>
            </td>
          </tr>
        </tbody>
      </table>
      <table class="table table-condensed">
        <tbody>
          <tr>
            <td class="col-sm-6 no-left-padding no-right-padding">
              <table class="table table-inner table-condensed">
                <tbody>
                  <tr>
                    <th>Clinical Size Type and Measurement Description</th>
                  </tr>
                  <tr>
                    <td [ngClass]="isDefault('Clinical Size Type and Measurement Description')"> <label
                        controlName="clinicalSizesDescription"></label></td>
                  </tr>
                </tbody>
              </table>
            </td>
          </tr>
        </tbody>
      </table>
      <table class="table table-condensed">
        <tbody>
          <tr>
            <td class="col-sm-12 no-left-padding no-right-padding" >
              <table formArrayName="storageHandlingForm" class="table table-inner table-condensed ">
                <tbody>
                  <tr>
                    <th class="col-sm-3">Storage and Handling Conditions</th>
                    <th class="col-sm-1">Low Value</th>
                    <th class="col-sm-1">High Value</th>
                    <th class="col-sm-1">Unit</th>
                    <th class="col-sm-4"><span class="left-padding-8">Comments</span></th>
                    <th class="col-sm-2"><span class="left-padding-8">Language</span></th>
                  </tr>
                  <ng-container *ngIf="storageHandlingForm.controls.length; else emptyTemplate6fields">
                    <tr formGroupName="{{i}}" *ngFor="let storage of storageHandlingForm.controls; let i = index" [ngClass]="isDefault('Storage and Handling Conditions')">
                    <td  [ngClass]="isDefault('Storage and Handling Conditions')">
                      <label controlName="storageHandlingCondition"></label>
                    </td>
                    <td  [ngClass]="isDefault('Storage and Handling Conditions')">
                      <label controlName="valueLow"></label>
                    </td>
                    <td  [ngClass]="isDefault('Storage and Handling Conditions')">
                      <label controlName="valueHigh"></label>
                    </td>
                    <td  [ngClass]="isDefault('Storage and Handling Conditions')">
                      <label controlName="unit"></label>
                    </td>

                    <td  [ngClass]="isDefault('Storage and Handling Conditions')">
                      <table formArrayName="storageHandlingComments" class="table table-inner table-condensed" >
                        <tr formGroupName="{{i}}"
                          *ngFor="let comment of storage.get('storageHandlingComments').controls; let i = index">
                          <td class="no-top-padding-inner-table">
                            <label controlName="comments"></label>
                          </td>
                        </tr>
                      </table>
                    </td>

                    <td [ngClass]="isDefault('Storage and Handling Conditions')">
                      <table formArrayName="storageHandlingComments" class="table table-inner table-condensed">
                        <tr formGroupName="{{i}}"
                          *ngFor="let comment of storage.get('storageHandlingComments').controls; let i = index">
                          <td class="no-top-padding-inner-table">
                            <label controlName="languageQualifier"></label>
                          </td>
                        </tr>
                      </table>
                    </td>
                  </tr>
                  </ng-container>

                </tbody>
              </table>
            </td>
          </tr>
        </tbody>
      </table>
      <table class="table table-condensed">
        <tbody>

          <tr>
            <td class="col-sm-12 no-left-padding no-right-padding">

              <table class="table table-inner table-condensed">
                <tbody>
                  <tr>
                    <th class="col-sm-4">Special Storage and Handling Condition</th>
                    <th class="col-sm-4">Storage Condition</th>
                    <th class="col-sm-4">Distribution and Handling Condition</th>
                  </tr>
                  <tr>
                    <td [ngClass]="isDefault('Special Storage and Handling Condition')"> <label
                        controlName="specialStorageHandlingCondition"></label></td>
                    <td [ngClass]="isDefault('Storage Condition')"> <label controlName="storageCondition"></label></td>
                    <td [ngClass]="isDefault('Distribution and Handling Condition')"> <label
                        controlName="distributionAndHandlingCondition"></label></td>
                  </tr>
                </tbody>
              </table>

            </td>
          </tr>
        </tbody>
      </table>
      <table class="table table-condensed">
        <tbody>
          <tr>
            <td class="col-sm-7 no-left-padding">
              <table class="table table-inner table-condensed">
                <tbody>
                  <tr>
                    <th colspan="2">INTENDED PURPOSE OTHER THAN MEDICAL</th>
                  </tr>
                  <tr>
                    <td class="col-sm-10">Intended to be Totally or Partially Introduced into the Human Body?</td>
                    <td class="col-sm-2"
                      [ngClass]="isDefault('Intended to be Totally or Partially Introduced into the Human Body?')">
                      <label controlName="intoductedToHumandBody"></label>
                    </td>
                  </tr>
                  <tr>
                    <td>Contact Lenses?</td>
                    <td [ngClass]="isDefault('Contact Lenses?')">
                      <label controlName="contactLenses"></label>
                    </td>
                  </tr>
                  <tr>
                    <td>Brain Electrostimulation?</td>
                    <td [ngClass]="isDefault('Brain Electrostimulation?')">
                      <label controlName="brainElectroStimulation"></label></td>
                  </tr>
                  <tr>
                    <td>High Intensity Electromagnetic Radiation?</td>
                    <td [ngClass]="isDefault('High Intensity Electromagnetic Radiation?')">
                      <label controlName="highIntencityRadiation"></label></td>
                  </tr>
                  <tr>
                    <td>Equipment to Reduce, Remove or Destroy Adipose Tissue?</td>
                    <td [ngClass]="isDefault('Equipment to Reduce, Remove or Destroy Adipose Tissue?')">
                      <label controlName="equipmentToDestroyTissue"></label>
                    </td>
                  </tr>
                  <tr>
                    <td>Intended for Filling by Injection?</td>
                    <td [ngClass]="isDefault('Intended for Filling by Injection?')">
                      <label controlName="intendedForInjection"></label></td>
                  </tr>
                </tbody>
              </table>
            </td>
            <td class="col-sm-6"></td>
          </tr>
        </tbody>
      </table>
      <table *ngIf="dataScope.toLowerCase() === dataScopeEnum.SKOREA.toLowerCase()" class="table table-condensed">
        <tbody>
          <tr>
            <td class="col-sm-12 no-left-padding no-right-padding">
              <table class="table table-inner table-condensed">
                <tbody>
                  <tr>
                    <th class="col-sm-6">Registering Duplicate UDI-DI?</th>
                    <th class="col-sm-6">Reason for Registering Duplicate UDI-DI</th>
                  </tr>
                  <tr>
                    <td [ngClass]="isDefault('Registering Duplicate UDI-DI?')">
                      <label controlName="registeringDuplicateUdidi"></label>
                    </td>
                    <td [ngClass]="isDefault('Reason for Registering Duplicate UDI-DI')">
                      <label controlName="reasonForRegisteringDuplicateUdidi"></label>
                    </td>
                  </tr>
                </tbody>
              </table>
            </td>
          </tr>
        </tbody>
      </table>
    </form>
  </div>
</div>
<ng-template #emptyTemplate1field>
  <tr>
    <td><label class="label-padding-bottom-15"></label></td>
  </tr>
</ng-template>
<ng-template #emptyTemplate6fields>
  <tr>
    <td><label class="label-padding-bottom-15"></label></td>
    <td><label class="label-padding-bottom-15"></label></td>
    <td><label class="label-padding-bottom-15"></label></td>
    <td><label class="label-padding-bottom-15"></label></td>
    <td><label class="label-padding-bottom-15"></label></td>
    <td><label class="label-padding-bottom-15"></label></td>
  </tr>
</ng-template>
<ng-template #emptyTemplate10fields>
  <tr>
    <td><label class="label-padding-bottom-15"></label></td>
    <td><label class="label-padding-bottom-15"></label></td>
    <td><label class="label-padding-bottom-15"></label></td>
    <td><label class="label-padding-bottom-15"></label></td>
    <td><label class="label-padding-bottom-15"></label></td>
    <td><label class="label-padding-bottom-15"></label></td>
    <td><label class="label-padding-bottom-15"></label></td>
    <td><label class="label-padding-bottom-15"></label></td>
    <td><label class="label-padding-bottom-15"></label></td>
    <td><label class="label-padding-bottom-15"></label></td>
  </tr>
</ng-template>
